import { render, staticRenderFns } from "./OneParallel.vue?vue&type=template&id=926fdb24&scoped=true&"
import script from "./OneParallel.vue?vue&type=script&lang=js&"
export * from "./OneParallel.vue?vue&type=script&lang=js&"
import style0 from "./OneParallel.vue?vue&type=style&index=0&id=926fdb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926fdb24",
  null
  
)

export default component.exports